import { render, staticRenderFns } from "./JudeScreenshotUploder.vue?vue&type=template&id=08cfe603&scoped=true"
import script from "./JudeScreenshotUploder.vue?vue&type=script&lang=js"
export * from "./JudeScreenshotUploder.vue?vue&type=script&lang=js"
import style0 from "./JudeScreenshotUploder.vue?vue&type=style&index=0&id=08cfe603&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cfe603",
  null
  
)

export default component.exports